import React from 'react'
import styled from 'styled-components'
import LoadingIndicator from '../LoadingIndicator'

const LoadingOverlayWrapper = styled.div`
    opacity: 0.2;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    text-align: center;
    font-size: 1.2em;
    color: #FFF;
    background: rgba(0, 0, 0, 0.7);
    z-index: 800;
    transition: opacity 500ms ease-in;
    opacity: 1;
`

interface LoadingOverlayProps {
    active: boolean
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ active, children }) => {
    return (
        <>
            {active && <LoadingOverlayWrapper id="loading-overlay"><LoadingIndicator progress={null} /></LoadingOverlayWrapper >}
            {children}
        </>
    )
}

export default LoadingOverlay
